import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { truncate } from '../util';

class Component extends BaseComponent {
    componentDidMount() {
        this.start = new Date();
        if (!this.props.psychics) {
            this.props.getPsychics(this.props.mode);
        }

        const finish = new Date();
        this.trackImpression(finish - this.start);
    }

    render({ psychics }) {
        if (psychics) {
            return (
                <oranum-psychics>
                    <h3>
                        Online Spiritual Advisors
                        <span>Chat now for up to 10 minutes free!</span>
                    </h3>
                    <row>
                        {psychics.map(psychic => this.renderPsychic(psychic))}
                    </row>
                </oranum-psychics>
            );
        }

        return <oranum-psychics />;
    }

    renderPsychic = (psychic) => {
        const last = psychic.likes.lastIndexOf(' ');
        const truncated_likes = psychic.likes.substring(0, last);
        const likes = psychic.likes != truncated_likes ? truncated_likes + '…' : psychic.likes;

        return (
            <column className='is-12-mobile is-6'>
                <a href={psychic.link} target='_blank' rel='noopener' onClick={this.trackClick}>
                    <img src={psychic.thumb} alt={psychic.performerid} />
                    <h4>{psychic.performerid}</h4>
                </a>
                <p>{truncate(likes, 70)}</p>
                <a className='arrow' href={psychic.link} target='_blank' rel='noopener' onClick={this.trackClick}>
                    ENTER MY FREE CHAT ROOM
                </a>
            </column>
        );
    }

    trackImpression = (loadTime) => {
        const action = this.props.logged_in ? 'LI Impression' : 'LO Impression';
        this.props.trackEvent(['Psychics', action, 'Oranum-XML', loadTime]);
    }

    trackClick = () => {
        const action = this.props.logged_in ? 'LI Click' : 'LO Click';
        this.props.trackEvent(['Psychics', action, 'Oranum-XML']);
    }

}

const mapStateToProps = (state) => ({
    psychics: state.oranum && state.oranum.psychics,
    logged_in: state.user && state.user.logged_in,
});

const mapDispatchToProps = (dispatch) => ({
    trackEvent: (payload) => dispatch({ type: 'ga:event', payload: payload }),
    getPsychics: (mode) => dispatch({
        type: 'oranum:get-psychics',
        payload: {
            mode: mode,
        },
    }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);

